import { serviceO as axiosIns } from '../utils/axios';
export const headerForm = {
    'content-type': 'application/x-www-form-urlencoded'
};

export const headerJson = {
    'content-type': 'application/json'
};

/**
 * 会员的指导方案列表
 * @param {*} data 
 * @param {*} params 
 */
export function myGuidRecordList(data,params) {
    return axiosIns({
        url: `ncdpSurvey/interveneRecord/findInterveneRecordList`,
        method: 'POST',
        data,
        params
    })
}

/**
 * 医生为会员生成指导方案--这时候仍未进入数据库
 */
export function createGuidePlan(data){
    return axiosIns({
        url: 'ncdpSurvey/interveneRecord/createInterveneRecord',
        method: 'POST',
        data
    })
}

/**
 * 根据会员ID、指导方案记录ID查询指导方案详情
 * 
 */
export function myGuidRecordDetail(data) {
    return axiosIns({
        url: `ncdpSurvey/interveneRecord/queryInterveneByRecordId/${data.memberCode}/${data.recordId}`,
        method: 'GET',
        data
    })
}

/**
 * 撤回指导方案
 * ${staffCode, recordId} params
 */
export function recallGuidePlan(params) {
    return axiosIns({
        url: `ncdpSurvey/interveneRecord/revokeInterveneRecord/${params.staffCode}/${params.recordId}`,
        method: 'GET',
        params
    })
}

/**
 * 保存指导方案
 */
export function saveGuidePlan(data){
    return axiosIns({
        url: 'ncdpSurvey/interveneRecord/saveInterveneRecord',
        method: 'POST',
        data
    })
}

/**
 * 更新指导方案
 */
export function updateGuidePlan(data){
    return axiosIns({
        url: 'ncdpSurvey/interveneRecord/updateIntervene',
        method: 'POST',
        data
    })
}

/**
 * 发送指导方案
 * ${staffCode, recordId} params
 */
export function sendGuidePlan(params) {
    return axiosIns({
        url: `ncdpSurvey/interveneRecord/sendInterveneRecord/${params.staffCode}/${params.recordId}`,
        method: 'GET',
        params
    })
}

/**
 * 查询指导方案列表
 */
export function getGuidePlans(data,params){
    return axiosIns({
        url: 'ncdpSurvey/interveneManager/listInterveneType',
        method: 'post',
        data,
        params
    })
}

/**
 * 工作台-指导方案-指导方案-测评记录
 */
export function myEvalRecordList(data,params) {
    return axiosIns({
        url: `ncdpSurvey/answerAndResult/queryAppSurveyAnswerList`,
        method: 'post',
        data,
        params
    })
}

/**
 * 工作台-指导方案-指导方案-发送通知
 * ${staffCode  -- staffCode, memberCode  -- memberCode, surveyId -- 量表ID, urlSuffix -- 当前页面路由和参数 } params
 */

 export function noticeMessage(data) {
     return axiosIns({
         url: 'survey/surveyMsg/sendSurveyNotifyMessage',
         method: 'POST',
         data
     })
 }

/**
 * 指导方案对应的测评量表接口
 */
export function getSurveyByGuideId(data) {
    return axiosIns({
        url: 'ncdpSurvey/appSurvey/getAppSurveyList',
        method: 'POST',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/guidePlan.js